import { render, staticRenderFns } from "./addNedit-series.vue?vue&type=template&id=ec611ce6&scoped=true&"
import script from "./addNedit-series.vue?vue&type=script&lang=js&"
export * from "./addNedit-series.vue?vue&type=script&lang=js&"
import style0 from "./addNedit-series.vue?vue&type=style&index=0&id=ec611ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec611ce6",
  null
  
)

export default component.exports